import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text} from 'react-native';
import { APP_DATE, FONT_STYLE } from '../../dataSchema/const';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const styles = StyleSheet.create({
  container: {
    marginTop: 16,
    width: '100%',
    height: 56,
    borderRadius: 8,
    borderColor: '#333333',
    borderWidth: 1,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    paddingLeft: 16,
  },
  errorText:{
    padding: 5,
    fontSize:14,
    fontFamily: FONT_STYLE.MEDIUM,
    color:'red',
    marginTop: 15
  }
});

const MIN_DATE = new Date();
MIN_DATE.setFullYear(new Date().getFullYear() - 99);

const MAX_DATE = new Date();
MAX_DATE.setFullYear(new Date().getFullYear() - 18);

const DateTimePicker = ({ onSelect, defaultAnswer=null }) => {
  const [currentDate, setCurrentDate]=  useState(null);
  const [inValid, setInValid]=  useState(false);

  useEffect(()=>{
    if(defaultAnswer && defaultAnswer.values){
      let date = moment(defaultAnswer.values[0],'DD/MM/yyyy').toDate();
      setCurrentDate(date);
    }
  },[])

  const onConfirm = (date: Date) => {
    const currentTime = Date.now();
    if(date.getTime() > currentTime){
      setInValid(true);
      return;
    } 
    const parsedDate = moment(date).format('DD/MM/yyyy');
    setInValid(false);
    setCurrentDate(date);
    if(onSelect){
        onSelect(parsedDate);
    }
  };

  return (
    <>
      {
        inValid ? (
        <Text style={styles.errorText}>
          {`Nhập thời gian không hợp lệ`}
        </Text>
        ): null
      } 
      <View style={styles.container} >       
      <DatePicker 
            placeholderText='Nhập thời gian tại đây'
            selected={currentDate}
            onChange={onConfirm}
            dateFormat={APP_DATE}
            portalId='root-portal'
            customInput={
            <input
                style={{
                  fontFamily:FONT_STYLE.MEDIUM,
                  width:"100%",
                  height:"50",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
    
                }}
              />
            }
          >
        </DatePicker>
      </View>
    </>
  ); 
};

export default DateTimePicker;
